<i18n>
{
	"en": {
		"all": "All",
		"save": "Save",
		"title": "Quick search",
		"cancelLabel": "Cancel",
		"subheader": {
			"text": "Choose which saved searches you want to show up in the menu.",
			"title": "Quick search"
		}
	},
	"no": {
		"all": "Alle",
		"save": "Lagre",
		"title": "Hurtigsøk",
		"cancelLabel": "Avbryt",
		"subheader": {
			"text": "Velg hvilke av de lagrede hurtigsøkene som skal vises i menyen.",
			"title": "Hurtigsøk"
		}
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:confirmLabel="$t('save')"
		:cancelLabel="$t('cancelLabel')"
		:title="$t('title')"
		icon="cog"
		iconType="bp"
		width="480px"
		@ok="onSaveOrderMenuSettings"
		@close="onClose"
		@shown="showGrid = true"
	>

		<div class="menu-sub-header">
			<div class="menu-sub-header-title">{{$t('subheader.title')}}</div>
			<div class="menu-sub-header-text">{{$t('subheader.text')}}</div>
		</div>

		<t-grid
			v-if="showGrid"
			ref="grid"
			:items="filteredSavedSearches"
			:columnDefinitions="columnDefinitions"
			:defaultColumnDefinition="defaultColumnDefinition"
			:rowHeight="50"
			:selectedIds="selectedSavedSearches"
			:showFilters="false"
			class="menu-grid"
			selectable
		/>

	</t-dialog>
</template>

<script>
import { mapState, mapActions } from './store/saveOrderSearch.store.js';
export default {
	name: 'Settings',
	props: { isShown: Boolean },
	data() {
		return {
			showGrid: false,
			columnDefinitions: undefined,
			defaultColumnDefinition: { resizable: false, }
		};
	},
	computed: {
		...mapState(['settingsSavedSearches']),
		filteredSavedSearches() {
			return this.settingsSavedSearches.filter(x => x.id !== -1);
		},
		selectedSavedSearches() {
			return this.filteredSavedSearches.filter(x => x.mainMenu).map(x => x.id);
		}
	},
	watch: {
		isShown(newVal) {
			if (newVal) {
				this.getSettingsSavedSearches();
			}
		}
	},
	beforeMount() {
		this.columnDefinitions = [
			{
				field: 'label',
				displayName: this.$t('all'),
				width: 400,
			},
		];
	},
	methods: {
		...mapActions([
			'getSettingsSavedSearches',
			'updateSavedSearchesOnMainMenu'
		]),

		onSaveOrderMenuSettings() {
			let items = this.$refs.grid.getSelectedItems();
			this.updateSavedSearchesOnMainMenu(items);
			this.showGrid = false;
		},
		onClose() {
			this.$emit('close');
			this.showGrid = false;
		}
	},
};
</script>

<style lang="scss" scoped>
	@import '~@/components/evergreen/scss/colors';
	@import '~@/components/evergreen/scss/text';

.menu-sub-header {
	@extend %text-small;
	padding-bottom: 20px;
	border-bottom: solid 1px #e4e7eb;
}

.menu-sub-header-title {
	font-weight: 600;
	color: get-color($text, 'dark');
}

.menu-sub-header-text {
	color: get-color($text, 'muted');
}

.menu-grid {
	margin-top: 20px;
	height: 480px;
	width: 100%;
}
</style>
